"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var apisauce_1 = tslib_1.__importDefault(require("apisauce"));
var config_1 = tslib_1.__importDefault(require("./config"));
var instances = {};
var create = function (baseURL, auth0ClientId, auth0Connection) {
    var instanceId = baseURL;
    if (typeof instances[instanceId] !== 'undefined') {
        console.log('auth0 cached', instanceId);
        return instances[instanceId];
    }
    var api = apisauce_1.default.create({
        baseURL: baseURL,
        headers: {
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        timeout: config_1.default.TIMEOUT
    });
    var buildClientLogin = function () { return '/oauth/ro'; };
    var defaults = {
        'client_id': auth0ClientId,
        'grant_type': 'password',
        'connection': auth0Connection,
        'scope': 'openid offline_access app_metadata',
        'device': 'integration_test'
    };
    var clientLogin = function (params) {
        return api
            .post(buildClientLogin(), tslib_1.__assign(tslib_1.__assign({}, defaults), params))
            .then(function (response) {
            if (response.ok) {
                return response.data;
            }
            else {
                throw new Error('Could not log into auth0'); // response.data
            }
        });
    };
    instances[instanceId] = {
        clientLogin: clientLogin
    };
    return instances[instanceId];
};
exports.default = {
    create: create
};
